<app-header-one></app-header-one>

<section class="listing-categories-area pt-100 pb-70">
    <div class="container">
        <div class="section-title">
            <h2>Hospital <span class="single-text">View</span></h2>
        </div>
        <div class="row">
            <div class="col-lg-12" style="margin-top: -30px">
                <img
                    src="assets/img/walter-otto-PT70CT6mATQ-unsplash.png"
                    width="100%"
                    style="height: 450px !important"
                />
            </div>

            <div class="col-lg-12 text-left" style="margin-top: 15px">
                <h2>Covid Can Rebound !!!</h2>
            </div>
            <div class="col-lg-12 text-left" style="margin-top: 5px">
                <span class="view">
                    <mat-icon svgIcon="view"></mat-icon> 7.4K</span
                >
                <span class="comment">
                    <mat-icon svgIcon="comment"></mat-icon> 45</span
                >
            </div>

            <div class="col-lg-12 text-left" style="margin-top: 10px">
                <p class="description">
                    Contrary To Popular Belief, Lorem Ipsum Is Not Simply Random
                    Text. It Has Roots In A Piece Of Classical Latin Literature
                    From 45 BC, Making It Over 2000 Years Old. Richard
                    Mcclintock, A Latin Professor At Hampden-Sydney College In
                    Virginia, Looked Up One Of The More Obscure Latin Words,
                    Consectetur, From A Lorem Ipsum Passage, And Going Through
                    The Cites Of The Word In Classical Literature, Discovered
                    The Undoubtable Source. Lorem Ipsum Comes From Sections
                    1.10.32 And 1.10.33 Of "De Finibus Bonorum Et Malorum" (The
                    Extremes Of Good And Evil) By Cicero, Written In 45 BC. This
                    Book Is A Treatise On The Theory Of Ethics, Very Popular
                    During The Renaissance. The First Line Of Lorem Ipsum,
                    "Lorem Ipsum Dolor Sit Amet..", Comes From A Line In Section
                    1.10.32. The Standard Chunk Of Lorem Ipsum Used Since The
                    1500S Is Reproduced Below For Those Interested. Sections
                    1.10.32 And 1.10.33 From "De Finibus Bonorum Et Malorum" By
                    Cicero Are Also Reproduced In Their Exact Original Form,
                    Accompanied By English Versions From The 1914 Translation By
                    H. Rackham. Contrary To Popular Belief, Lorem Ipsum Is Not
                    Simply Random Text. It Has Roots In A Piece Of Classical
                    Latin Literature From 45 BC, Making It Over 2000 Years Old.
                    Richard Mcclintock, A Latin Professor At Hampden-Sydney
                    College In Virginia, Looked Up One Of The More Obscure Latin
                    Words, Consectetur, From A Lorem Ipsum Passage, And Going
                    Through The Cites Of The Word In Classical Literature,
                    Discovered The Undoubtable Source. Lorem Ipsum Comes From
                    Sections 1.10.32 And 1.10.33 Of "De Finibus Bonorum Et
                    Malorum" (The Extremes Of Good And Evil) By Cicero, Written
                    In 45 BC. This Book Is A Treatise On The Theory Of Ethics,
                    Very Popular During The Renaissance. The First Line Of Lorem
                    Ipsum, "Lorem Ipsum Dolor Sit Amet..", Comes From A Line In
                    Section 1.10.32.
                </p>
                <p class="description">
                    The Standard Chunk Of Lorem Ipsum Used Since The 1500S Is
                    Reproduced Below For Those Interested. Sections 1.10.32 And
                    1.10.33 From "De Finibus Bonorum Et Malorum" By Cicero Are
                    Also Reproduced In Their Exact Original Form, Accompanied By
                    English Versions From The 1914 Translation By H. Rackham.
                </p>
                <p class="description">
                    Contrary To Popular Belief, Lorem Ipsum Is Not Simply Random
                    Text. It Has Roots In A Piece Of Classical Latin Literature
                    From 45 BC, Making It Over 2000 Years Old. Richard
                    Mcclintock, A Latin Professor At Hampden-Sydney College In
                    Virginia, Looked Up One Of The More Obscure Latin Words,
                    Consectetur, From A Lorem Ipsum Passage, And Going Through
                    The Cites Of The Word In Classical Literature, Discovered
                    The Undoubtable Source. Lorem Ipsum Comes From Sections
                    1.10.32 And 1.10.33 Of "De Finibus Bonorum Et Malorum" (The
                    Extremes Of Good And Evil) By Cicero, Written In 45 BC. This
                    Book Is A Treatise On The Theory Of Ethics, Very Popular
                    During The Renaissance. The First Line Of Lorem Ipsum,
                    "Lorem Ipsum Dolor Sit Amet..", Comes From A Line In Section
                    1.10.32. The Standard Chunk Of Lorem Ipsum Used Since The
                    1500S Is Reproduced Below For Those Interested. Sections
                    1.10.32 And 1.10.33 From "De Finibus Bonorum Et Malorum" By
                    Cicero Are Also Reproduced In Their Exact Original Form,
                    Accompanied By English Versions From The 1914 Translation By
                    H. Rackham. Contrary To Popular Belief, Lorem Ipsum Is Not
                    Simply Random Text. It Has Roots In A Piece Of Classical
                    Latin Literature From 45 BC, Making It Over 2000 Years Old.
                    Richard Mcclintock, A Latin Professor At Hampden-Sydney
                    College In Virginia,
                </p>
            </div>

          
        </div>
    </div>
</section>